import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";

/**✅ Branch Departments Thunk */
export const branchDepartmentThunk = createAsyncThunk(
    "general/branchDepartmentThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;
     
        // 👈 Skip API if data already in state
        if (payload.type !== "getBranchDepartment") {
            if (state.general?.branchDepartments?.length > 0) {
                return state.general.branchDepartments;
            }
        }

        try {
            const response = await api.post(API_ROUTES.BRANCH_DEPARTMENTS, {
                employee_id: user?.user_id,
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branch departments");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**  ✅ Departments Thunk */
export const departmentThunk = createAsyncThunk(
    "general/departmentThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "getDepartment") {
            if (state.general?.departments?.length > 0) {
                return state.general.departments;
            }
        }

        try {
            const response = await api.post(API_ROUTES.DEPARTMENTS, {
                employee_id: user?.user_id,
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch departments");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ Branches Thunk **/
export const branchThunk = createAsyncThunk(
    "general/branchThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "getBranch") {
            if (state.general?.branches?.length > 0) {
                return state.general.branches;
            }
        }

        try {
            const response = await api.post(API_ROUTES.BRANCHS, {
                employee_id: user?.user_id,
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branches");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ add Branches Thunk **/
export const addBranchThunk = createAsyncThunk(
    "general/addBranchThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_BRANCH, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);

/**✅ add Department Thunk **/
export const addDepartmentThunk = createAsyncThunk(
    "general/addDepartmentThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_DEPARTMENT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);

/**✅ add branch Department Thunk **/
export const addBranchDepartmentThunk = createAsyncThunk(
    "general/addBranchDepartmentThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_BRANCH_DEPARTMENT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);

/**✅ add branch Department Thunk **/
export const uploadFileThunk = createAsyncThunk(
    "general/uploadFileThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            "client_id": user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.FILE_UPLOAD, payload);
            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                    data
                };
            }

            return rejectWithValue(message || "File failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "File failed"
            );
        }
    }
);